import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { clear } from "console";
import { set } from "date-fns";

interface ClientTokenState {
    token: string | undefined;
    clerkId: string | undefined;
    profile: {
        userid: number;
        username?: string;
        firstName?: string;
        lastName?: string;
        companyId?: number;
        companyName?: string;
        industry?: string;
        department?: string;
        role?: string;
    };
}

const initialState: ClientTokenState = {
    token: undefined,
    clerkId: undefined,
    profile: {
        userid: 0,
        username: "",
        firstName: "",
        lastName: "",
        companyId: 0,
        companyName: "",
        industry: "",
        department: "",
        role: ""
    }
};

const clientTokenSlice = createSlice({
    name: "clientToken",
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload;
        },
        setClerkId: (state, action: PayloadAction<string>) => {
            state.clerkId = action.payload;
        },
        setProfile: (state, action: PayloadAction<ClientTokenState["profile"]>) => {
            state.profile = action.payload;
        },
        clearClerkId: state => {
            state.clerkId = undefined;
        },
        clearToken: state => {
            state.token = undefined;
        },
        clearProfile: state => {
            state.profile = {
                userid: 0,
                username: "",
                firstName: "",
                lastName: "",
                companyId: 0,
                companyName: "",
                industry: "",
                department: "",
                role: ""
            };
        }
    }
});

export const { setToken, clearToken, setClerkId, clearClerkId, setProfile, clearProfile } = clientTokenSlice.actions;
export default clientTokenSlice.reducer;
